import React, { useRef, useEffect, useState, useMemo } from "react";
import Axios from "axios";

import { withMemo } from "../../utils/functions";

const cleanSVG = svg => {
    return svg.replace(/<\/?svg.*?>/g, "");
};

const Avatar = withMemo(
    ({ className, svg }) => {
        const svgRef = useRef();
        const [svgData, setSvgData] = useState("");
        const api = useMemo(() => Axios.get(svg), [svg]);

        useEffect(() => {
            let mounted = true;
            api
                .then(data => {
                    if (data && mounted) {
                        setSvgData(cleanSVG(data.data));
                    }
                })
                .catch(e => {
                    console.log(e);
                });
            return () => {
                mounted = false;
            };
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        return (
            <svg
                className={className}
                ref={svgRef}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="175 47 155 155"
                dangerouslySetInnerHTML={{ __html: svgData }}
            />
        );
    },
    ["className", "svg"]
);

export default Avatar;
